import foundations from "./readerGuides/foundations.json";
import embodied from "./readerGuides/embodied.json";
import agriculture from "./readerGuides/agriculture.json";
import logistics from "./readerGuides/logistics.json";
import services from "./readerGuides/services.json";
import marine from "./readerGuides/marine.json";
import aerial from "./readerGuides/aerial.json";
import health from "./readerGuides/health.json";

// Only these reviewed source revisions replace the legacy category renderer.
// The revision date records an editorial change, not a human or clinical sign-off.
export const readerGuides = [
  ...foundations, ...embodied, ...agriculture, ...logistics,
  ...services, ...marine, ...aerial, ...health,
].map((guide) => ({ ...guide, updated: guide.updated || "2026-10-06" }));

export const readerGuideByPath = Object.fromEntries(
  readerGuides.map((guide) => [guide.path, guide]),
);
